import React, { Component } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import MutasiDetailNoQrTab from "./mutasiBarangDetailTabHadiahDanBarangLain/mutasiDetailNoQrTab";
import MutasiDetailQrTab from "./mutasiBarangDetailTabHadiahDanBarangLain/mutasiDetailQrTab";

class MutasiBarangDetailTabBarangLain extends Component {
  render() {
    return (
      <Tabs>
        <TabList>
          <Tab>Tanpa QR</Tab>
          <Tab>Dengan QR</Tab>
        </TabList>
        <TabPanel>
          <MutasiDetailNoQrTab
            state={this.props.state}
            onSetState={this.props.onSetState}
            buttonType={this.props.buttonType}
            tab="barangLain"
            mutasiKeluarTab={this.props.mutasiKeluarTab}
          />
        </TabPanel>
        <TabPanel>
          <MutasiDetailQrTab
            state={this.props.state}
            onSetState={this.props.onSetState}
            buttonType={this.props.buttonType}
            tab="barangLain"
            mutasiKeluarTab={this.props.mutasiKeluarTab}
          />
        </TabPanel>
      </Tabs>
    );
  }
}

export default MutasiBarangDetailTabBarangLain;
